import React from "react"
import { useTranslation } from "react-i18next"
import { Link, useLocation, useParams } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumbs = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const pathnames = location.pathname.split("/").filter(x => x)
  const {
    bannerId,
    categoryId,
    itemId,
    modifierOptionId,
    modifierItemId,
    couponGroupId,
    couponUsageId,
  } = useParams()
  const dynamicRoutes = ["slides", "menus"] // Define dynamic route segments here
  const dynamicParams = [
    bannerId,
    categoryId,
    itemId,
    modifierOptionId,
    modifierItemId,
    couponGroupId,
    couponUsageId,
  ]

  const formatBreadcrumbLabel = label => {
    // Replace hyphens with spaces and capitalize each word
    return label
      .split("-")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  }

  return (
    <Row>
      <Col xs={12}>
        <div className="custom_breadcumb page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">
            {t(formatBreadcrumbLabel(pathnames[pathnames.length - 1]))}
          </h4>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="/dashboard">{t("Dashboard")}</Link>
              </BreadcrumbItem>
              {pathnames.map((name, index) => {
                const isLast = index === pathnames.length - 1
                const isDynamic =
                  dynamicRoutes.includes(name) || name.startsWith(":")
                const isHideUrl = dynamicParams.includes(name)
                if (isDynamic || isHideUrl) {
                  return null // Skip dynamic parts in breadcrumb
                }
                const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`
                return (
                  <BreadcrumbItem key={name} active={isLast}>
                    {/* {console.log(formatBreadcrumbLabel(name))} */}
                    {isLast ? (
                      t(formatBreadcrumbLabel(name))
                    ) : (
                      <Link to={routeTo}>{t(formatBreadcrumbLabel(name))}</Link>
                    )}
                  </BreadcrumbItem>
                )
              })}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default Breadcrumbs
